module.exports = __webpack_public_path__ + "static/media/avatar.ace2f8c0.svg";